<template>
  <div>
    <div class="grid_half">
      <v-card elevation="6" class="mr-md-2 mr-lg-2 mr-xl-2">
        <div class="pa-3">
          <div class="grid_header_dairy">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_top_ten" :src="img_top_ten"/>
            </div>
            <div class="pt-3 pl-2" style="font-size: 24px"><b>สินค้าขายดี 10 อันดับ</b></div>
          </div>
          <div class="ma-2">
            <v-data-table :headers="header_top" key="index" :items="orderBestSellerTopTen" hide-default-footer mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.index + 1 }}</td>
                  <td>{{ dataDetail.item.product_code }}</td>
                  <td>{{ dataDetail.item.name }}</td>
                  <!-- <td>{{ dataDetail.item.name_sci }}</td> -->
                  <td>{{ dataDetail.item.unit_name }}</td>
                  <td>{{ format_number(dataDetail.item.qty) }}</td>
                  <td>{{ format_number(dataDetail.item.total) }} บาท</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>
      <v-card elevation="6" class="ml-md-2 ml-lg-2 ml-xl-2">
        <div class="pa-3">
          <div class="grid_header_dairy">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product" :src="img_product"/>
            </div>
            <div class="pt-3 pl-2" style="font-size: 24px"><b>สินค้าขายไม่ดี 10 อันดับ</b></div>
          </div>
          <div class="ma-2">
            <v-data-table :headers="header_customer" key="index" :items="orderBadSellerTopTen" hide-default-footer mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.index + 1 }}</td>
                  <td>{{ dataDetail.item.product_code }}</td>
                  <td>{{ dataDetail.item.name }}</td>
                  <!-- <td>{{ dataDetail.item.name_sci }}</td> -->
                  <td>{{ dataDetail.item.unit_name }}</td>
                  <td>{{ format_number(dataDetail.item.qty) }}</td>
                  <td>{{ format_number(dataDetail.item.total) }} บาท</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>
    </div>
    <div class="mt-3">
      <v-card elevation="6">
        <div class="pa-3">
          <div class="grid_header_dairy">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product_emp" :src="img_product_emp"/>
            </div>
            <div class="pt-3 pl-2" style="font-size: 24px"><b>ลูกค้าที่มียอดสั่งซื้อมากที่สุด 10 อันดับ</b></div>
          </div>
          <div class="ma-2">
            <v-data-table :headers="header_emp" key="index" :items="customerTopTen" hide-default-footer mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.index + 1 }}</td>
                  <td>{{ dataDetail.item.name }}</td>
                  <td>{{ dataDetail.item.tel }}</td>
                  <td>{{ dataDetail.item.customer_type }}</td>
                  <td>{{ format_number(dataDetail.item.total) }} บาท</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import img_top_ten from "@/assets/medal.png";
import img_product from "@/assets/low-price.png";
import img_product_emp from "@/assets/best-employee.png";
import {formatNumber} from "@/js/handler";
import {HTTP} from "@/axios";

export default {
  name: "Sell_total_top",
  loading_top: false,
  loading_product: false,
  data() {
    return {
      img_top_ten: img_top_ten,
      img_product: img_product,
      img_product_emp: img_product_emp,
      header_top: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '100px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '120px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '100px',
        },
        {
          text: 'ยอดขาย',
          value: 'total',
          fixed: true,
          width: '120px',
        },
      ],
      header_customer: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '100px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '120px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '100px',
        },
        {
          text: 'ยอดขาย',
          value: 'total',
          fixed: true,
          width: '120px',
        },
      ],
      header_emp: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '150px',
        },
        // {
        //   text: 'รหัสลูกค้า',
        //   value: 'customer_code',
        //   fixed: true,
        //   width: '180px',
        // },
        {
          text: 'ชื่อลูกค้า',
          value: 'name',
          fixed: true,
          width: '400px',
        },
        {
          text: 'เบอร์โทร',
          value: 'tel',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ประเภทลูกค้า',
          value: 'customer_type',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ยอดสั่งซื้อ',
          value: 'total',
          fixed: true,
          width: '180px',
        },
      ],
      customerTopTen: [],
      orderBadSellerTopTen: [],
      orderBestSellerTopTen: [],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    get_data() {
      HTTP.get('wholesales/sellsaletotalreporttopten')
          .then((res) => {
            if (res.data.success === true) {
              this.customerTopTen = res.data.customerTopTen
              this.orderBadSellerTopTen = res.data.orderBadSellerTopTen
              this.orderBestSellerTopTen = res.data.orderBestSellerTopTen
            }
          })
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.grid_header_dairy {
  display: grid;
  grid-template-columns: 10% 90%;
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_header_dairy {
    display: grid;
    grid-template-columns: 15% 85%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_header_dairy {
    display: grid;
    grid-template-columns: 25% 75%;
  }
}
</style>
